export const FOOTER_SIMPLE_LINKS = [
  {
    label: 'Помощь',
    url: 'https://help.rambler.ru/id/'
  },
  {
    label: 'Обратная связь',
    url: 'https://help.rambler.ru/feedback/id/'
  },
  {
    label: 'Условия использования',
    url: 'https://help.rambler.ru/legal/id/'
  },
  {
    label: 'Политика конфиденциальности',
    url: 'https://help.rambler.ru/legal/1142/'
  }
]

export const FOOTER_SOCIAL_LINKS = [
  {
    code: 'vk',
    url: 'https://vk.com/rambler'
  },
  {
    code: 'ok',
    url: 'https://ok.ru/rambler'
  },
  {
    code: 'tg',
    url: 'https://t.me/news_rambler'
  }
]
